import { IPlatform } from "../entity/platforms/IPlatform";
import { IListResponse } from "../entity/platforms/IResponse";

export const convertToArrayPlatforms = (serverResponse: IListResponse): IPlatform[] => {
  const {
    minAndroidVersion,
    minIosVersion,
    recommendedAndroidVersion,
    recommendedIosVersion,
    storeLinks
  } = serverResponse;

  return [
    {
      id: 1,
      name: "Android",
      minimal_version: minAndroidVersion,
      recommended_version: recommendedAndroidVersion,
      link: storeLinks.android
    },
    {
      id: 2,
      name: "iOS", 
      minimal_version: minIosVersion,
      recommended_version: recommendedIosVersion,
      link: storeLinks.IOS
    }
  ];
};